import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { useConfig } from './contexts/ConfigContext'
import { useUser } from './contexts/UserContext'
import { useCompany } from './contexts/CompanyContext'
import { useLocation } from 'react-router-dom'
import Auth from './hooks/useAuth'

function App({ children }: Readonly<{ children?: React.ReactNode }>) {
  const { config, updateConfig } = useConfig()
  const { updateUser } = useUser()
  const { updateCompanies } = useCompany()
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const sessionQuery = params.get('session')
  const session = sessionQuery || config.session || localStorage.getItem('session') || ''

  // Obtener Token de la sesión
  const { tokenData } = Auth.useToken('authCsrfToken', session, config.key)
  // Cargar información del usuario administrador
  const { data: baseData } = Auth.useLoadBase(tokenData, session)

  useEffect(() => {
    const activeSession = sessionQuery || localStorage.getItem('session') || ''
    if (activeSession) {
      localStorage.setItem('session', activeSession)
      if (config.session !== activeSession) {
        updateConfig({ session: activeSession })
      }
    }
  }, [sessionQuery, config.session, updateConfig])

  const isForbiddenRedirect = (response: any) => {
    return (response?.status === 401 || response?.status === 403) && response?.redirect
  }
    
  useEffect(() => {
    if (tokenData && isForbiddenRedirect(tokenData)) {
      const redirect = btoa(window.location.href)
      const targetUrl = tokenData.redirect
      window.location.href = targetUrl + (targetUrl.includes('?') ? '&' : '?') + "redirect=" + redirect
      return
    }

    console.log("Token Data",tokenData)
    console.log("Base Data",baseData)
    if (tokenData && baseData) {
      if (isForbiddenRedirect(baseData)) {
        const redirect = btoa(window.location.href)
        const targetUrl = baseData.redirect
        window.location.href = targetUrl + (targetUrl.includes('?') ? '&' : '?') + "redirect=" + redirect
        return
      }

      updateConfig({ key: tokenData.key, showProgress: false, token: tokenData?.token?.uid })
      
      // Mapear permisos del usuario
      const permissionsList = baseData.roles 
        ? baseData.roles.flatMap((r: any) => (r.permissions || []).map((p: any) => p.key))
        : []

      updateUser({
        id: baseData.id,
        name: baseData.name,
        image: baseData.image,
        uid: baseData.uid,
        adminScope: baseData.adminScope,
        adminCompanyId: baseData.adminCompanyId,
        permissions: {
          views: permissionsList.filter((k: string) => k.includes('.view')),
          actions: permissionsList.filter((k: string) => !k.includes('.view'))
        }
      })

      // Cargar lista de empresas en el contexto si aplica
      if (baseData.companies) {
        updateCompanies({
          list: baseData.companies,
          current: baseData.companies[0] || { name: '', modules: [], icon: '', uid: '' }
        })
      }
    }
  }, [tokenData, baseData, updateConfig, updateUser, updateCompanies])

  if (!tokenData || !baseData || baseData.status === 401 || baseData.status === 403 || baseData.status >= 400 || !config.key) {
    if (baseData && (baseData.status === 403 || baseData.status >= 400)) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
          <h3 style={{ color: '#cf1322' }}>Acceso denegado o error de autenticación</h3>
          <p>{baseData.message || 'No fue posible validar la sesión en el módulo de administración.'}</p>
        </div>
      )
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spin size="large" />
        <h3 style={{ marginTop: 16 }}>Inicializando módulo administrativo...</h3>
      </div>
    )
  }

  return <>{children}</>
}

export default App
